import Request from './request';
import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import { getSaveableDateWithTime } from "../utils/DateHelper";
import FieldNames from "../defaults/FieldNames.json";


const GeneralService = {
  queryCall: function(url, queryObject){
    const sanitizedQueryObj = this.sanitizeQueryObject(queryObject);
    return query.executeQueryJSON(url, sanitizedQueryObj).then(results => {
      let features = [];
      if(results.features) {
        features = results.features.map((eaGroup) => eaGroup.attributes);
      } 
      return features
    });
  },

  // Returns results directly without mapping values
  queryCallDirect: function(url, queryObject, optionsObj = null){
    const sanitizedQueryObj = this.sanitizeQueryObject(queryObject);
    return query.executeQueryJSON(url, sanitizedQueryObj, optionsObj).then(results => {
      return results;
    });
  },

  queryCallSingle: function(url, queryObject, optionsObj = null){
    const sanitizedQueryObj = this.sanitizeQueryObject(queryObject);
    return query.executeQueryJSON(url, sanitizedQueryObj, optionsObj).then(results => {
      let features = [];
      if(results.features) {
        features = results.features.map((eaGroup) => { return { attributes: eaGroup.attributes, geometry: eaGroup.geometry }});
      } 
      return features[0]
    });
  },
  

  // Note: executeForCount by default doesn't seem to get past the maxRecordCount set for the server
  queryCountCall: function(url, queryObject, optionsObj){
    const sanitizedQueryObj = this.sanitizeQueryObject(queryObject);
    return query.executeForCount(url, sanitizedQueryObj, optionsObj).then(results => {
      return results;
    });
  },

  updateCallForMultiples: async function(featureUrl, nifcToken, itemsToRun){
    return new Promise((resolve, reject) => {
      new Request().makeRequest({
        url: featureUrl,
        method: 'post',
        data: {
            f: 'json',
            token: nifcToken,
            features: JSON.stringify(itemsToRun)
        }
      }).then(
          resp => {
            resolve(resp);
          },
          error => {
            reject(error)
          }
      );
    });
  },

  queryForLayers: function(rootServiceUrl, nifcToken){
    return new Request()
      .makeRequest({
        url: rootServiceUrl,
        method: "get",
        data: {
          f: "json",
          token: nifcToken,
        },
      })
      .then(
        (resp) => {
          let combinedLayerTableArr = resp.layers.concat(resp.tables);
          return combinedLayerTableArr;
        },
        (error) => {
          return error;
        }
      );
  },

  sanitizeQueryObject: function(queryObject)
  {
    if(!queryObject?.where)
    {
      return queryObject
    }

    let newQueryObj = queryObject;
    const querySanitizedApostrophes = newQueryObj.where.replace(/(?<!['"(\%]|=|= |,|, |LIKE |> |date )'(?!['"),\%]| OR| AND|\n| \n)/gm, "''")
    newQueryObj.where = querySanitizedApostrophes;
    return newQueryObj;
  }
};

export default GeneralService;